module.exports = __webpack_public_path__ + "media/images/clone_plus-9b37ce64.svg";